import {
  Box,
  TextField,
  MenuItem,
  Typography,
} from "@mui/material";
import {
  AGGREGATION_TYPES,
  AggregationType,
  FIELDS_BY_AGGREGATION,
  INTERVAL_OPTIONS,
} from "./widgetBuilderConstants";

interface AggregationConfigProps {
  aggregationType: AggregationType;
  field: string;
  interval: string;
  size: number;
  onAggregationTypeChange: (type: AggregationType) => void;
  onFieldChange: (field: string) => void;
  onIntervalChange: (interval: string) => void;
  onSizeChange: (size: number) => void;
}

export default function AggregationConfig({
  aggregationType,
  field,
  interval,
  size,
  onAggregationTypeChange,
  onFieldChange,
  onIntervalChange,
  onSizeChange,
}: Readonly<AggregationConfigProps>) {
  const availableFields = FIELDS_BY_AGGREGATION[aggregationType];
  const showField = availableFields.length > 0;
  const showInterval = aggregationType === "dateHistogram";
  const showSize = aggregationType === "terms";

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography variant="overline" color="text.secondary">
        Data
      </Typography>

      <TextField
        select
        label="Aggregation"
        value={aggregationType}
        onChange={(e) => onAggregationTypeChange(e.target.value as AggregationType)}
        size="small"
        fullWidth
      >
        {AGGREGATION_TYPES.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </TextField>

      {showField && (
        <TextField
          select
          label="Field"
          value={field}
          onChange={(e) => onFieldChange(e.target.value)}
          size="small"
          fullWidth
        >
          {availableFields.map((f) => (
            <MenuItem key={f.value} value={f.value}>
              {f.label}
            </MenuItem>
          ))}
        </TextField>
      )}

      {showInterval && (
        <TextField
          select
          label="Interval"
          value={interval}
          onChange={(e) => onIntervalChange(e.target.value)}
          size="small"
          fullWidth
        >
          {INTERVAL_OPTIONS.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </TextField>
      )}

      {showSize && (
        <TextField
          label="Top N Results"
          type="number"
          value={size}
          onChange={(e) => {
            const val = parseInt(e.target.value, 10);
            if (!isNaN(val) && val > 0) onSizeChange(val);
          }}
          size="small"
          fullWidth
          inputProps={{ min: 1, max: 100 }}
        />
      )}
    </Box>
  );
}
